module.exports = __webpack_public_path__ + "assets/trigger_payment_applied.020a5c6c.svg";